<template>
  <RevInfoBlock
    :content="i18n(translations.content)"
    :cta="i18n(translations.buttonLabel, { productModel })"
    :icon="IconWarning"
    :title="i18n(translations.title)"
    variant="warning"
    @click="onClick"
  />
</template>

<script setup lang="ts">
import { navigateTo, useRequestURL } from '#imports'

import type { ProductPageLink } from '@backmarket/http-api/src/api-specs-content/models/price-guide'
import { transformHref } from '@backmarket/nuxt-layer-cms/utils/transformHref'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'

import translations from './OutOfStockProductExists.translations'

const i18n = useI18n()
const currentUrl = useRequestURL()

const props = defineProps<{
  productModel: string
  fallbackProductPageLink: ProductPageLink
}>()

const onClick = async () => {
  await navigateTo(
    transformHref({
      href: props.fallbackProductPageLink.href,
      currentUrl,
    }).href,
  )
}
</script>
